module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"on-sort":"На сортировке","way":"Путь"},"en":{"on-sort":"On sorting","way":"Way"}}')
  delete Component.options._Ctor
}
